import { ThemeEvents } from '@theme/events';

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const { html } = /** @type {CustomEvent} */ (event).detail.data;
  document.querySelectorAll('[data-variant-block-id]').forEach((el) => {
    if (!(el instanceof HTMLElement)) return;
    const newEl = html.querySelector(`[data-variant-block-id="${el.dataset.variantBlockId}"]`);
    if (!newEl) return;
    const contentEl = el.querySelector('[data-variant-block-content]');
    const newContentEl = newEl.querySelector('[data-variant-block-content]');
    if (contentEl && newContentEl) {
      contentEl.replaceWith(newContentEl);
    } else {
      el.replaceWith(newEl);
    }
  });
});
